import { FileMimeByExt } from "@/components/IBFile/interface";
import { FileImgUrlsByMime } from "@/modules/File/interface";

export const fileImgUrlByMime = {
	[FileMimeByExt.jpg]: '/img/icons/photo.svg',
	[FileMimeByExt.png]: '/img/icons/photo.svg',
	[FileMimeByExt.pdf]: '/img/icons/pdf.svg',
	[FileMimeByExt.xls]: '/img/icons/table.svg',
	[FileMimeByExt.xlsx]: '/img/icons/table.svg',
	[FileMimeByExt.docx]: '/img/icons/docx.svg',
} as FileImgUrlsByMime;